import { getActiveRule } from './rule';
export function setStyleMetadata(key, value) {
    const activeRule = getActiveRule();
    if (!activeRule.metadata) {
        activeRule.metadata = {};
    }
    activeRule.metadata[key] = value;
}
export function getStyleMetadata(key) {
    const activeRule = getActiveRule();
    if (activeRule.metadata) {
        return activeRule.metadata[key];
    }
}

//# sourceMappingURL=metadata.js.map